import { render, staticRenderFns } from "./ActionsList.vue?vue&type=template&id=6bb04421&scoped=true&"
import script from "./ActionsList.vue?vue&type=script&lang=ts&"
export * from "./ActionsList.vue?vue&type=script&lang=ts&"
import style0 from "./ActionsList.vue?vue&type=style&index=0&id=6bb04421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb04421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VIcon,VSkeletonLoader})
